import * as React from "react";
import {
  List,
  ListItem,
  ListItemText,
  Hidden,
  Drawer,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  withStyles,
  createStyles,
  Theme,
  Avatar,
  ListItemSecondaryAction,
  Divider,
  Menu,
  MenuItem
} from "@material-ui/core";
import * as routes from "./routes";
import store from "./store";
import * as headerActions from "./store/header/actions";
import {
  Route,
  Link,
  Redirect,
  RouteProps,
  withRouter
} from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import HomeIcon from "@material-ui/icons/Home";
import InboxIcon from "@material-ui/icons/Inbox";
import PeopleIcon from "@material-ui/icons/People";
import TagIcon from "@material-ui/icons/TagFaces";
import FolderIcon from "@material-ui/icons/Folder";
import CategoryIcon from "@material-ui/icons/Category";
import UserIcon from "@material-ui/icons/PersonAdd";
import {
  getUserName,
  getUserPicture,
  logout,
  userGroups,
  DEFAULT_AVATAR
} from "./auth/auth";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import MailIcon from "@material-ui/icons/MailOutline";
import {
  ROLE_ENGAGEMENT_EDITOR,
  ROLE_ADMIN,
  ROLE_GUEST,
  ROLE_WRITER
} from "./api/constants";
import ToolsIcon from "@material-ui/icons/Build";
import { RouterProps } from "react-router";
import StarIcon from "@material-ui/icons/Star";

interface Props extends RouterProps {
  classes: any;
  hasAuth?: boolean;
}
interface State {
  mobileOpen: boolean;
  anchorEl: any;
}
export const drawerWidth = 240;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      height: 440,
      zIndex: 1,
      overflow: "hidden",
      position: "relative",
      display: "flex",
      width: "100%",
      backgroundColor: "#FCFCFC"
    },
    appBar: {
      position: "absolute",
      backgroundColor: "white",

      [theme.breakpoints.up("md")]: {
        display: "none"
      }
    },
    navIconHide: {
      [theme.breakpoints.up("md")]: {
        display: "none"
      }
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
      width: drawerWidth,
      [theme.breakpoints.up("md")]: {
        position: "relative"
      }
    },
    content: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing.unit * 3
    },
    logo: {
      flex: 1,
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      [theme.breakpoints.up("md")]: {
        left: drawerWidth
      }
    }
  });

class NavDrawer extends React.Component<Props, State> {
  state = {
    mobileOpen: false,
    anchorEl: null
  };
  handleNavigate = () => {
    //store.dispatch(headerActions.closeDrawer());
    this.setState(state => ({ mobileOpen: false }));
  };
  handleDrawerToggle = () => {
    this.setState(state => ({ mobileOpen: !state.mobileOpen }));
  };
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };
  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  renderInbox = () => {
    if (
      userGroups() !== ROLE_ADMIN &&
      userGroups() !== ROLE_ENGAGEMENT_EDITOR
    ) {
      return null;
    }
    return (
      <Link
        to={routes.PATH_MESSAGES}
        onClick={this.handleNavigate}
        style={{ textDecoration: "none" }}
      >
        <ListItem button>
          <InboxIcon color="action" />
          <ListItemText primary="Inbox" />
        </ListItem>
      </Link>
    );
  };
  renderReports = () => {
    if (
      userGroups() !== ROLE_ADMIN &&
      userGroups() !== ROLE_ENGAGEMENT_EDITOR
    ) {
      return null;
    }
    return (
      <Link
        to={routes.PATH_REPORTS}
        onClick={this.handleNavigate}
        style={{ textDecoration: "none" }}
      >
        <ListItem button>
          <PeopleIcon color="action" />
          <ListItemText primary="Reports" />
        </ListItem>
      </Link>
    );
  };
  renderUsers = () => {
    if (userGroups() !== ROLE_ADMIN) {
      return null;
    }
    return (
      <Link
        to={routes.PATH_USERS}
        onClick={this.handleNavigate}
        style={{ textDecoration: "none" }}
      >
        <ListItem button>
          <UserIcon color="action" />
          <ListItemText primary="Users" />
        </ListItem>
      </Link>
    );
  };
  renderMailList = () => {
    if (userGroups() !== ROLE_ADMIN) {
      return null;
    }
    return (
      <Link
        to={routes.PATH_MAIL_LIST}
        onClick={this.handleNavigate}
        style={{ textDecoration: "none" }}
      >
        <ListItem button>
          <MailIcon color="action" />
          <ListItemText primary="Mail Notification" />
        </ListItem>
      </Link>
    );
  };
  renderTools = () => {
    if (
      userGroups() !== ROLE_ADMIN &&
      userGroups() !== ROLE_WRITER &&
      userGroups() !== ROLE_ENGAGEMENT_EDITOR
    ) {
      return null;
    }
    return (
      <Link
        to={routes.PATH_TOOLS}
        onClick={this.handleNavigate}
        style={{ textDecoration: "none" }}
      >
        <ListItem button>
          <ToolsIcon color="action" />
          <ListItemText primary="Tools" />
        </ListItem>
      </Link>
    );
  };
  render() {
    const { classes } = this.props;
    const open = Boolean(this.state.anchorEl);

    const drawer = (
      <div
        style={{
          width: drawerWidth,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          backgroundColor: "#FCFCFC"
        }}
      >
        <div className={classes.toolbar} style={{ marginTop: 8 }}>
          <img
            src="/assets/img/dubito.png"
            height={24}
            style={{ marginLeft: 32, marginTop: 12, alignSelf: "center" }}
          />
        </div>

        <List disablePadding style={{ flex: 1 }}>
          <Link
            to={routes.PATH_MAIN}
            onClick={this.handleNavigate}
            style={{ textDecoration: "none" }}
          >
            <ListItem button>
              <HomeIcon color="action" />
              <ListItemText primary="Dashboard" />
            </ListItem>
          </Link>
          <Link
            to={routes.PATH_CASES}
            onClick={this.handleNavigate}
            style={{ textDecoration: "none" }}
          >
            <ListItem button>
              <FolderIcon color="action" />
              <ListItemText primary="Cases" />
            </ListItem>
          </Link>
          <Link
            to={routes.PATH_STARRED + "?starred=true"}
            onClick={this.handleNavigate}
            style={{ textDecoration: "none" }}
          >
            <ListItem button>
              <StarIcon color="action" />
              <ListItemText primary="Starred Cases" />
            </ListItem>
          </Link>
          {this.renderInbox()}
          {this.renderReports()}

          <Link
            to={routes.PATH_TAGS}
            onClick={this.handleNavigate}
            style={{ textDecoration: "none" }}
          >
            <ListItem button>
              <div
                style={{
                  marginRight: 6,
                  marginLeft: 6,
                  fontSize: 20,
                  color: "gray"
                }}
              >
                #
              </div>
              <ListItemText primary="Tags" />
            </ListItem>
          </Link>
          <Link
            to={routes.PATH_CATEGORIES}
            onClick={this.handleNavigate}
            style={{ textDecoration: "none" }}
          >
            <ListItem button>
              <CategoryIcon color="action" />
              <ListItemText primary="Categories" />
            </ListItem>
          </Link>
          {this.renderUsers()}
          {this.renderMailList()}
          {this.renderTools()}
        </List>
        <Divider />
        <List style={{ marginBottom: 12 }}>
          <ListItem dense button className={classes.listItem}>
            <Avatar
              alt="Remy Sharp"
              src={getUserPicture()}
              onError={(e: any) => {
                e.target.onerror = null;
                e.target.src = DEFAULT_AVATAR;
              }}
            />
            <ListItemText primary={getUserName()} />
            <ListItemSecondaryAction>
              <IconButton onClick={this.handleClick}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={this.state.anchorEl}
                open={open}
                onClose={this.handleClose}
                PaperProps={{
                  style: {
                    maxHeight: 48 * 4.5,
                    width: 200
                  }
                }}
              >
                <MenuItem
                  onClick={() => {
                    this.props.history.push("/settings");
                    this.handleClose();
                  }}
                >
                  {"Settings"}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    logout();
                    this.handleClose();
                  }}
                >
                  {"Logout"}
                </MenuItem>
                ))}
              </Menu>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </div>
    );
    return (
      <div>
        <AppBar position="absolute" className={classes.appBar}>
          <Toolbar>
            <div className={classes.logo}>
              <img
                src="/assets/img/dubito.png"
                height={24}
                style={{ marginLeft: 8, alignSelf: "center" }}
              />
            </div>
            <IconButton
              color="primary"
              aria-label="Open drawer"
              onClick={this.handleDrawerToggle}
              className={classes.navIconHide}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        {this.props.hasAuth && (
          <Hidden mdUp>
            <Drawer
              variant="temporary"
              anchor={"left"}
              open={this.state.mobileOpen}
              onClose={() => this.setState({ mobileOpen: false })}
              classes={{}}
              ModalProps={{
                keepMounted: true // Better open performance on mobile.
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
        )}
        {this.props.hasAuth && (
          <Hidden smDown implementation="css">
            <Drawer
              variant="permanent"
              open
              classes={
                {
                  //paper: classes.drawerPaper
                }
              }
            >
              {drawer}
            </Drawer>
          </Hidden>
        )}
      </div>
    );
  }
}
export default withRouter(withStyles(styles)(NavDrawer) as any) as any;



// WEBPACK FOOTER //
// ./src/drawer.tsx